import api from "./api";
import { buildVCard } from "./vcard";

async function photoBase64(path) {
  const { data } = await api.get(`/files/${path}`, { responseType: "blob" });
  const bmp = await createImageBitmap(data);
  const scale = Math.min(1, 480 / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", 0.8).split(",")[1];
}

async function vcardWithPhoto(card) {
  let photo = "";
  if (card.image_path) {
    try { photo = await photoBase64(card.image_path); } catch { photo = ""; }
  }
  return buildVCard(card, photo);
}

function download(content, filename) {
  const url = URL.createObjectURL(new File([content], filename, { type: "text/vcard" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function saveToPhoneContacts(card) {
  download(await vcardWithPhoto(card), `${(card.name || card.company || "contact").replace(/\s+/g, "_")}.vcf`);
}

export async function saveManyToPhoneContacts(cards) {
  const parts = [];
  for (let i = 0; i < cards.length; i += 6) {
    parts.push(...(await Promise.all(cards.slice(i, i + 6).map(vcardWithPhoto))));
  }
  download(parts.join("\r\n"), "dextyou-contacts.vcf");
}
